import {Button, ConfigProvider, Input} from "antd";
import React, {useEffect, useState} from "react";
import WorkforceDetailsFieldComponent from "../../../components/WorkForce/WorkforceDetailsFieldComponent";
import {useSelector} from "react-redux";

const CaseListingDetailsLocationDetails = () => {
    const { workforceCaseDetails } = useSelector((state) => state.Workforce);
    const [workforceLocationDetails, setWorkforceLocationDetails] = useState({});

    useEffect(() => {
        setWorkforceLocationDetails(workforceCaseDetails);
    }, [workforceCaseDetails]);

    return (
        <>
            <div className="flex flex-col gap-2">
                <div className="text-sm font-bold">
                    <label htmlFor={"location"}>
                        <p>Location</p>
                    </label>
                </div>
                <div>
                    <ConfigProvider
                        theme={{
                            token: {
                                colorPrimary: "blue",
                                borderRadius: 5,
                            },
                        }}
                    >
                        <WorkforceDetailsFieldComponent fieldName={""} fieldId={"fullAddress"}>
                            <Input
                                disabled={true}
                                placeholder=""
                                id={"fullAddress"}
                                value={workforceLocationDetails?.device?.address}
                                onChange={() => {
                                }}
                            />
                        </WorkforceDetailsFieldComponent>
                    </ConfigProvider>
                </div>
            </div>

            <div className="grid grid-cols-6">
                <div className="content-end">
                    <ConfigProvider>
                        <Button
                            disabled={true}
                            className="w-full bg-medium-blue-100 text-white"
                        >
                            Locate
                        </Button>
                    </ConfigProvider>
                </div>
                <div className="col-span-2 col-end-7">
                    <WorkforceDetailsFieldComponent
                        fieldName={"Geocode"}
                        fieldId={"geocode"}
                    >
                        <Input
                            disabled={true}
                            placeholder="0,0"
                            id={"geocode"}
                            value={workforceLocationDetails?.latitude?.toString()?.concat(", ")?.concat(workforceLocationDetails?.longitude?.toString())}
                        />
                    </WorkforceDetailsFieldComponent>
                </div>
            </div>
        </>
    );
};

export default CaseListingDetailsLocationDetails;
